import { ErrorMessage } from '@hookform/error-message'
import {
  CurrencyOptions,
  Hint,
  Input,
  MaskType
} from '@tecsinapse/cortex-react'
import React from 'react'
import { useController, useFormContext } from 'react-hook-form'

interface FormTextFieldMaskProps {
  name: string
  label?: string
  customOnBlur?: (e: React.FocusEvent<HTMLInputElement>) => void
  disabled?: boolean
  mask: (MaskType[] | ((value: string) => MaskType[])) | CurrencyOptions
}

export const FormTextFieldMask = ({
  name,
  label,
  customOnBlur,
  disabled,
  mask
}: FormTextFieldMaskProps) => {
  const { setValue, control } = useFormContext()
  const {
    field: { value, onBlur },
    formState: { submitCount, errors },
    fieldState: { isTouched, error }
  } = useController({ name, control })
  const success = isTouched && !error

  return (
    <div className={'w-full'}>
      <Input.Mask
        mask={mask}
        variants={{
          intent: (value ?? [])?.length > 1 && success ? 'success' : 'default'
        }}
        name={name}
        value={value ?? ''}
        label={label}
        onChange={value => setValue(name, value)}
        onBlur={e => {
          onBlur()
          if (customOnBlur) {
            customOnBlur(e)
          }
        }}
        disabled={disabled}
      />
      {(isTouched || submitCount > 0) && error ? (
        <ErrorMessage
          errors={errors}
          name={name}
          render={({ message }) => (
            <Hint variants={{ intent: 'error' }}>{String(message)}</Hint>
          )}
        />
      ) : null}
    </div>
  )
}
